export default {
  history: {
    title: "Activity History",
    loading: "Loading…",
    subtitle: "{month} {year} — {days} days with events · {total} events in total",
    prevMonth: "Previous month",
    nextMonth: "Next month",
    today: "Today",
    yesterday: "Yesterday",
    loadError: "Couldn't load the information. Check your connection.",
    retry: "Retry",
    changes: "events",
    portfolio: "portfolio",
    competitor: "competitor",
    sourceFilter: "Filter by source",
    allSources: "All sources",
    footerSource: "HelixScan has monitored {name} since {date}. The history keeps all its events since that first check.",
    footerAll: "HelixScan has monitored since {date}, when its first sources started; each source has its own date (pick one above or see Sources). The history keeps all events since each source's first check.",
    noChanges: "No events recorded in {month} {year}",
    // Change types (calendar legend + cards)
    typeNewEntry: "New entry",
    typePriceChange: "Price change",
    typeReimbursement: "Reimbursement",
    typeExclusion: "Exclusion",
    typeDeduction: "Deduction",
    typeWarning: "Notice",
    typeMarketingStatus: "Market status",
    typeEuRegistration: "EU registration",
    typeRegulation: "Regulation",
    typeExclusivity: "Exclusivity",
    // Months
    month0: "January",
    month1: "February",
    month2: "March",
    month3: "April",
    month4: "May",
    month5: "June",
    month6: "July",
    month7: "August",
    month8: "September",
    month9: "October",
    month10: "November",
    month11: "December",
    // Day initials (M=Monday … S=Sunday)
    day0: "M",
    day1: "T",
    day2: "W",
    day3: "T",
    day4: "F",
    day5: "S",
    day6: "S",
  },
};
